module.exports = __webpack_public_path__ + "img/dashboard.d227cb93.svg";